// TODO: ! NO LONGER MAINTAINED ! This module is deprecated and will no longer be maintained.
// https://github.com/webpack-contrib/script-loader
import 'script-loader!select2';

/**
 * set Bindhandlers.
 */
function bindHandlers() {
    const $select = $('.js-select2');

    if ($select.length) {
        $select.select2();
    }
}

/**
 * check if we need to initialise
 */
$(document).ready(bindHandlers);